import React, { useState, useEffect, useRef } from 'react'
import { Accordion, Card, Button } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../Resources/Resource.css'
import 'font-awesome/css/font-awesome.min.css'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'

// Skeleton CSS
const skeletonStyle = {
  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)',
  backgroundSize: '400% 100%',
  animation: 'skeleton-loading 1.2s ease-in-out infinite',
  borderRadius: '4px',
  minHeight: '20px',
  width: '100%',
  display: 'inline-block',
}

function ActPracticeTest() {
  const [data, setData] = useState([])
  const [testscount, settestscount] = useState([])
  const [ctestscount, setctestscount] = useState([])
  const [studentname, setstudentname] = useState([])
  const [loading, setLoading] = useState(true)
  const [students, setStudents] = useState([])
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const dropdownRef = useRef(null)

  // Get role and user info
  const rolename = localStorage.getItem('role')
  let userid = localStorage.getItem('userid')

  // Get student_id from query string
  const urlParams = new URLSearchParams(location.search)
  let student_id = urlParams.get('student_id')
  if (student_id && student_id !== '') userid = student_id

  // Fetch students for parent
  useEffect(() => {
    if (rolename === 'parent') {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}get_students/${localStorage.getItem(
            'userid'
          )}`
        )
        .then((res) => {
          setStudents(res.data)
          // If no student_id in URL, redirect to first student
          if ((!student_id || student_id === '') && res.data.length > 0) {
            navigate(`/act_practice_tests?student_id=${res.data[0]._id}`)
          }
        })
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    getPracticeTests()
    // eslint-disable-next-line
  }, [student_id])

  const getPracticeTests = async () => {
    setLoading(true)
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getactpracticetest/${userid}`
    )
    if (response.status === 200) {
      setData(response.data.sattestsData)
      settestscount(response.data.overallTestsCount)
      setctestscount(response.data.completedTestsCount)
      setstudentname(response.data.studentName)
    }
    setLoading(false)
  }

  // Custom dropdown logic
  const handleDropdownToggle = () => setDropdownOpen((open) => !open)
  const handleDropdownSelect = (stu) => {
    setDropdownOpen(false)
    navigate(`/act_practice_tests?student_id=${stu._id}`)
  }
  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [dropdownOpen])

  // Get selected student name
  const selectedStudent =
    students.find((stu) => stu._id === student_id) || students[0]

  return (
    <section className="bg-white border rounded-[10px] border-[#F0F0F0] p-0">
      {/* Header and Summary */}
      <div
        className="flex items-center border-b border-[#F0F0F0] px-6 py-4"
        style={{ justifyContent: 'space-between' }}
      >
        {/* Title */}
        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-bold text-[#030303]">
            ACT Practice Test
          </h2>
        </div>
        {/* Dropdown Centered */}
        {rolename === 'parent' && students.length > 0 && (
          <div className="flex-1 flex justify-center min-w-0">
            <div
              ref={dropdownRef}
              style={{ position: 'relative', minWidth: 180 }}
            >
              <button
                onClick={handleDropdownToggle}
                className="bg-white rounded-xl shadow px-4 py-2 text-base font-semibold text-black flex items-center justify-between focus:outline-none"
                style={{
                  border: 'none',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                  minWidth: 180,
                  height: 44,
                }}
              >
                {selectedStudent
                  ? `${selectedStudent.first_name} ${selectedStudent.last_name}`
                  : 'Select Student'}
                <span style={{ fontSize: 18, marginLeft: 10 }}>&#9662;</span>
              </button>
              {dropdownOpen && (
                <div
                  className="absolute left-0 right-0 mt-2 bg-white rounded-xl shadow-lg z-50"
                  style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.18)' }}
                >
                  {students.map((stu, idx) => (
                    <div
                      key={stu._id}
                      onClick={() => handleDropdownSelect(stu)}
                      className="px-4 py-3 text-base font-semibold text-black cursor-pointer hover:bg-neutral-100"
                      style={{
                        borderTop: idx === 0 ? 'none' : '1px solid #eee',
                        borderRadius:
                          idx === 0
                            ? '16px 16px 0 0'
                            : idx === students.length - 1
                            ? '0 0 16px 16px'
                            : '0',
                      }}
                    >
                      {stu.first_name} {stu.last_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {/* Summary right-aligned */}
        <div className="flex-1 flex justify-end min-w-0">
          <div className="text-[#535862] text-base font-medium">
            You completed {ctestscount} of {testscount} tests.
          </div>
        </div>
      </div>
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-neutral-50">
            <tr>
              <th className="text-sm text-[#535862] font-medium text-left border px-5 py-3.5 border-[#F0F0F0]">
                Test #
              </th>
              <th className="text-sm text-[#535862] font-medium text-left border px-5 py-3.5 border-[#F0F0F0]">
                Date
              </th>
              <th className="text-sm text-[#535862] font-medium text-left border px-5 py-3.5 border-[#F0F0F0]">
                Status
              </th>
              <th className="text-sm text-[#535862] font-medium text-center border px-5 py-3.5 border-[#F0F0F0]">
                English
              </th>
              <th className="text-sm text-[#535862] font-medium text-center border px-5 py-3.5 border-[#F0F0F0]">
                Math
              </th>
              <th className="text-sm text-[#535862] font-medium text-center border px-5 py-3.5 border-[#F0F0F0]">
                Reading
              </th>
              <th className="text-sm text-[#535862] font-medium text-center border px-5 py-3.5 border-[#F0F0F0]">
                Science
              </th>
              <th className="text-sm text-[#535862] font-medium text-center border px-5 py-3.5 border-[#F0F0F0]">
                Total
              </th>
              <th className="text-sm text-[#535862] font-medium text-center border px-5 py-3.5 border-[#F0F0F0]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {loading
              ? Array.from({ length: 5 }).map((_, idx) => (
                  <tr key={idx} className="border border-[#F0F0F0]">
                    {Array.from({ length: 9 }).map((_, cidx) => (
                      <td
                        key={cidx}
                        className="px-5 py-3.5 border border-[#F0F0F0]"
                      >
                        <span style={skeletonStyle}>&nbsp;</span>
                      </td>
                    ))}
                  </tr>
                ))
              : data.map((item, index) => {
                  const originalDate = new Date(item.cdate)
                  const originalDate2 = new Date(item.codate)
                  const cdate = item.cdate
                    ? originalDate.toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })
                    : '-'
                  const codate = item.codate
                    ? originalDate2.toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })
                    : '-'
                  // Status badge
                  let statusBadge = null
                  if (
                    item.status === 'Assigned' &&
                    item.tstatus === 'Resume Test'
                  ) {
                    statusBadge = (
                      <span
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 10,
                          padding: '8px 10px',
                          borderRadius: 20,
                          background: '#FFF4E6',
                          width: 'fit-content',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M8.88994 1.16669H5.10994C2.91661 1.16669 2.74744 3.13835 3.93161 4.21169L10.0683 9.78835C11.2524 10.8617 11.0833 12.8334 8.88994 12.8334H5.10994C2.91661 12.8334 2.74744 10.8617 3.93161 9.78835L10.0683 4.21169C11.2524 3.13835 11.0833 1.16669 8.88994 1.16669Z"
                            stroke="#F36F4A"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span
                          style={{
                            color: '#F36F4A',
                            fontSize: 14,
                            fontWeight: 700,
                            lineHeight: '120%',
                            fontFamily: 'Basis Grotesque Arabic Pro',
                          }}
                        >
                          In Progress
                        </span>
                      </span>
                    )
                  } else if (item.status === 'Completed') {
                    statusBadge = (
                      <span
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 10,
                          padding: '8px 10px',
                          borderRadius: 20,
                          background: 'rgba(59, 188, 76, 0.10)',
                          width: 'fit-content',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_66_6333)">
                            <path
                              d="M7 13.5625C3.38144 13.5625 0.4375 10.6186 0.4375 7C0.4375 3.38144 3.38144 0.4375 7 0.4375C10.6186 0.4375 13.5625 3.38144 13.5625 7C13.5625 10.6186 10.6186 13.5625 7 13.5625ZM7 1.3125C3.864 1.3125 1.3125 3.864 1.3125 7C1.3125 10.136 3.864 12.6875 7 12.6875C10.136 12.6875 12.6875 10.136 12.6875 7C12.6875 3.864 10.136 1.3125 7 1.3125ZM6.43431 9.05931L10.3718 5.12181C10.5429 4.95075 10.5429 4.67425 10.3718 4.50319C10.2008 4.33213 9.92425 4.33213 9.75319 4.50319L6.125 8.13138L4.68431 6.69069C4.51325 6.51963 4.23675 6.51963 4.06569 6.69069C3.89463 6.86175 3.89463 7.13825 4.06569 7.30931L5.81569 9.05931C5.901 9.14463 6.013 9.1875 6.125 9.1875C6.237 9.1875 6.349 9.14463 6.43431 9.05931Z"
                              fill="#3BBC4C"
                              stroke="#3BBC4C"
                              strokeWidth="0.25"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_66_6333">
                              <rect width="14" height="14" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span
                          style={{
                            color: '#3BBC4C',
                            fontSize: 14,
                            fontWeight: 700,
                            lineHeight: '120%',
                            fontFamily: 'Basis Grotesque Arabic Pro',
                          }}
                        >
                          Completed
                        </span>
                      </span>
                    )
                  } else if (item.status === 'Assigned') {
                    statusBadge = (
                      <span
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 10,
                          padding: '8px 10px',
                          borderRadius: 20,
                          background: '#EAF6FF',
                          width: 'fit-content',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M6.53353 4.00128C6.38245 4.00128 6.23755 3.94126 6.13072 3.83443C6.02388 3.7276 5.96387 3.5827 5.96387 3.43162V1.15297C5.96387 1.00189 6.02388 0.856995 6.13072 0.750163C6.23755 0.643331 6.38245 0.583313 6.53353 0.583313C6.68461 0.583313 6.82951 0.643331 6.93634 0.750163C7.04317 0.856995 7.10319 1.00189 7.10319 1.15297V3.43162C7.10319 3.5827 7.04317 3.7276 6.93634 3.83443C6.82951 3.94126 6.68461 4.00128 6.53353 4.00128Z"
                            fill="#00A5D2"
                          />
                          <path
                            d="M6.53353 12.25C6.38245 12.25 6.23755 12.19 6.13072 12.0832C6.02388 11.9763 5.96387 11.8314 5.96387 11.6803V9.40169C5.96387 9.25061 6.02388 9.10571 6.13072 8.99888C6.23755 8.89205 6.38245 8.83203 6.53353 8.83203C6.68461 8.83203 6.82951 8.89205 6.93634 8.99888C7.04317 9.10571 7.10319 9.25061 7.10319 9.40169V11.6803C7.10319 11.8314 7.04317 11.9763 6.93634 12.0832C6.82951 12.19 6.68461 12.25 6.53353 12.25Z"
                            fill="#00A5D2"
                          />
                          <path
                            d="M3.5485 6.98631H1.26986C1.11877 6.98631 0.973878 6.92629 0.867045 6.81946C0.760213 6.71263 0.700195 6.56773 0.700195 6.41665C0.700195 6.26556 0.760213 6.12067 0.867045 6.01383C0.973878 5.907 1.11877 5.84698 1.26986 5.84698H3.5485C3.69959 5.84698 3.84448 5.907 3.95131 6.01383C4.05815 6.12067 4.11816 6.26556 4.11816 6.41665C4.11816 6.56773 4.05815 6.71263 3.95131 6.81946C3.84448 6.92629 3.69959 6.98631 3.5485 6.98631Z"
                            fill="#00A5D2"
                          />
                          <path
                            d="M11.7973 6.98631H9.51864C9.36755 6.98631 9.22266 6.92629 9.11582 6.81946C9.00899 6.71263 8.94897 6.56773 8.94897 6.41665C8.94897 6.26556 9.00899 6.12067 9.11582 6.01383C9.22266 5.907 9.36755 5.84698 9.51864 5.84698H11.7973C11.9484 5.84698 12.0933 5.907 12.2001 6.01383C12.3069 6.12067 12.3669 6.26556 12.3669 6.41665C12.3669 6.56773 12.3069 6.71263 12.2001 6.81946C12.0933 6.92629 11.9484 6.98631 11.7973 6.98631Z"
                            fill="#00A5D2"
                          />
                          <path
                            d="M8.64431 4.87559C8.53173 4.87539 8.42172 4.84183 8.3282 4.77915C8.23467 4.71647 8.16182 4.62748 8.11883 4.52342C8.07585 4.41936 8.06467 4.3049 8.08669 4.19449C8.10872 4.08408 8.16297 3.98267 8.24259 3.90307L9.85268 2.29229C9.90497 2.23683 9.96785 2.19243 10.0376 2.16171C10.1074 2.13099 10.1826 2.11459 10.2588 2.11347C10.335 2.11234 10.4107 2.12653 10.4813 2.15517C10.5519 2.18382 10.6161 2.22636 10.67 2.28025C10.7239 2.33415 10.7664 2.39831 10.7951 2.46895C10.8237 2.53958 10.8379 2.61524 10.8368 2.69146C10.8357 2.76767 10.8193 2.84288 10.7885 2.91264C10.7578 2.9824 10.7134 3.04528 10.658 3.09757L9.04672 4.7088C8.99392 4.76171 8.93119 4.80368 8.86214 4.8323C8.79309 4.86092 8.71906 4.87563 8.64431 4.87559Z"
                            fill="#00A5D2"
                          />
                          <path
                            d="M2.81174 10.7082C2.6991 10.7082 2.589 10.6747 2.49537 10.6121C2.40174 10.5494 2.32878 10.4605 2.28571 10.3564C2.24264 10.2523 2.2314 10.1378 2.25341 10.0273C2.27541 9.91682 2.32967 9.81535 2.40934 9.7357L4.02011 8.12561C4.07301 8.07271 4.13582 8.03074 4.20495 8.00211C4.27407 7.97348 4.34816 7.95874 4.42297 7.95874C4.49779 7.95874 4.57188 7.97348 4.641 8.00211C4.71013 8.03074 4.77293 8.07271 4.82584 8.12561C4.87874 8.17852 4.92071 8.24132 4.94934 8.31045C4.97797 8.37957 4.99271 8.45366 4.99271 8.52848C4.99271 8.6033 4.97797 8.67738 4.94934 8.74651C4.92071 8.81563 4.87874 8.87844 4.82584 8.93134L3.21461 10.541C3.16178 10.594 3.099 10.6361 3.02986 10.6648C2.96073 10.6935 2.8866 10.7083 2.81174 10.7082Z"
                            fill="#00A5D2"
                          />
                          <path
                            d="M4.42275 4.87559C4.34793 4.87569 4.27382 4.86101 4.20468 4.83239C4.13554 4.80376 4.07274 4.76176 4.01989 4.7088L2.40911 3.09757C2.35365 3.04528 2.30925 2.9824 2.27853 2.91264C2.24781 2.84288 2.23141 2.76767 2.23029 2.69146C2.22916 2.61524 2.24335 2.53958 2.272 2.46895C2.30065 2.39831 2.34318 2.33415 2.39707 2.28025C2.45097 2.22636 2.51514 2.18382 2.58577 2.15517C2.6564 2.12653 2.73206 2.11234 2.80828 2.11347C2.88449 2.11459 2.9597 2.13099 3.02946 2.16171C3.09922 2.19243 3.1621 2.23683 3.21439 2.29229L4.82562 3.90352C4.90531 3.98319 4.95958 4.08471 4.98157 4.19522C5.00356 4.30574 4.99228 4.4203 4.94915 4.5244C4.90603 4.62851 4.833 4.71748 4.7393 4.78008C4.6456 4.84267 4.53544 4.87607 4.42275 4.87605V4.87559Z"
                            fill="#00A5D2"
                          />
                          <path
                            d="M10.2556 10.7082C10.1808 10.7083 10.1067 10.6935 10.0375 10.6648C9.96838 10.6361 9.90559 10.594 9.85277 10.541L8.24268 8.9302C8.14474 8.8218 8.09219 8.67992 8.09589 8.53387C8.09959 8.38783 8.15925 8.24879 8.26255 8.14549C8.36586 8.04219 8.5049 7.98252 8.65094 7.97882C8.79698 7.97512 8.93887 8.02767 9.04727 8.12561L10.658 9.7357C10.7377 9.81537 10.792 9.91688 10.814 10.0274C10.836 10.1379 10.8247 10.2525 10.7816 10.3566C10.7385 10.4607 10.6654 10.5497 10.5717 10.6123C10.478 10.6749 10.3679 10.7082 10.2552 10.7082H10.2556Z"
                            fill="#00A5D2"
                          />
                        </svg>
                        <span
                          style={{
                            color: '#0492B9',
                            fontSize: 14,
                            fontWeight: 700,
                            lineHeight: '120%',
                            fontFamily: 'Basis Grotesque Arabic Pro',
                          }}
                        >
                          Assigned
                        </span>
                      </span>
                    )
                  }
                  // Action button
                  let actionButton = null
                  if (
                    item.status === 'Assigned' &&
                    item.tstatus === 'Start Test'
                  ) {
                    actionButton = !student_id ? (
                      <a
                        href={`/acttests/${item._id}`}
                        style={{
                          display: 'flex',
                          width: 110,
                          padding: 10,
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: 10,
                          borderRadius: 6,
                          background: '#DE3C7D',
                          color: '#FFF',
                          textAlign: 'center',
                          fontFamily: 'Basis Grotesque Arabic Pro',
                          fontSize: 15,
                          fontStyle: 'normal',
                          fontWeight: 500,
                          lineHeight: '120%',
                          border: 'none',
                          transition: 'background 0.2s',
                          textDecoration: 'none',
                        }}
                      >
                        <span style={{ marginBottom: 0, fontSize: 15 }}>
                          Start Test
                        </span>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 15 14"
                            fill="none"
                          >
                            <path
                              d="M9.11743 3.45917L12.6583 7L9.11743 10.5408"
                              stroke="white"
                              strokeWidth="1.2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M2.7417 7H12.5592"
                              stroke="white"
                              strokeWidth="1.2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </a>
                    ) : null
                  } else if (
                    item.status === 'Assigned' &&
                    item.tstatus === 'Resume Test'
                  ) {
                    actionButton = !student_id ? (
                      <a
                        href={`/acttests/${item._id}`}
                        style={{
                          display: 'flex',
                          width: 110,
                          padding: 10,
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: 10,
                          borderRadius: 6,
                          background: '#4E57EF',
                          color: '#FFF',
                          textAlign: 'center',
                          fontFamily: 'Basis Grotesque Arabic Pro',
                          fontSize: 15,
                          fontStyle: 'normal',
                          fontWeight: 500,
                          lineHeight: '120%',
                          border: 'none',
                          transition: 'background 0.2s',
                          textDecoration: 'none',
                        }}
                      >
                        <span style={{ marginBottom: 0, fontSize: 15 }}>
                          Resume
                        </span>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 15 14"
                            fill="none"
                          >
                            <path
                              d="M9.11743 3.45917L12.6583 7L9.11743 10.5408"
                              stroke="white"
                              strokeWidth="1.2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M2.7417 7H12.5592"
                              stroke="white"
                              strokeWidth="1.2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </a>
                    ) : null
                  } else if (item.status === 'Completed') {
                    actionButton = (
                      <a
                        href={`/act/testresults/${item._id}?student_id=${userid}`}
                        style={{
                          display: 'flex',
                          width: 110,
                          padding: 10,
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: 10,
                          borderRadius: 6,
                          background: '#EFEFEF',
                          color: '#030303',
                          textAlign: 'center',
                          fontFamily: 'Basis Grotesque Arabic Pro',
                          fontSize: 14,
                          fontStyle: 'normal',
                          fontWeight: 500,
                          lineHeight: '120%',
                          border: '1px solid #E5E7EB',
                          transition: 'background 0.2s',
                          textDecoration: 'none',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <span
                          style={{
                            marginBottom: 0,
                            fontSize: 14,
                            color: '#030303',
                            fontFamily: 'Basis Grotesque Arabic Pro',
                            fontWeight: 500,
                            lineHeight: '120%',
                          }}
                        >
                          View Results
                        </span>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 15 14"
                            fill="none"
                          >
                            <path
                              d="M9.28824 7.00002C9.28824 8.15502 8.35491 9.08835 7.19991 9.08835C6.04491 9.08835 5.11157 8.15502 5.11157 7.00002C5.11157 5.84502 6.04491 4.91168 7.19991 4.91168C8.35491 4.91168 9.28824 5.84502 9.28824 7.00002Z"
                              stroke="#535862"
                              strokeWidth="1.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.19986 11.8242C9.25903 11.8242 11.1782 10.6108 12.514 8.51082C13.039 7.68832 13.039 6.30582 12.514 5.48332C11.1782 3.38332 9.25903 2.16998 7.19986 2.16998C5.14069 2.16998 3.22153 3.38332 1.88569 5.48332C1.36069 6.30582 1.36069 7.68832 1.88569 8.51082C3.22153 10.6108 5.14069 11.8242 7.19986 11.8242Z"
                              stroke="#535862"
                              strokeWidth="1.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </a>
                    )
                  }
                  return (
                    <tr key={item._id} className="border border-[#F0F0F0]">
                      <td className="text-sm text-[#030303] border px-5 py-3.5 border-[#F0F0F0] font-semibold">
                        {item.test_title}
                      </td>
                      <td className="text-sm text-[#030303] border px-5 py-3.5 border-[#F0F0F0]">
                        {item.status === 'Completed' ? codate : cdate}
                      </td>
                      <td className="text-sm border px-5 py-3.5 border-[#F0F0F0]">
                        {statusBadge}
                      </td>
                      <td className="text-sm text-center border px-5 py-3.5 border-[#F0F0F0]">
                        {item.englishCount ?? '-'}
                      </td>
                      <td className="text-sm text-center border px-5 py-3.5 border-[#F0F0F0]">
                        {item.mathCount ?? '-'}
                      </td>
                      <td className="text-sm text-center border px-5 py-3.5 border-[#F0F0F0]">
                        {item.readingCount ?? '-'}
                      </td>
                      <td className="text-sm text-center border px-5 py-3.5 border-[#F0F0F0]">
                        {item.scienceCount ?? '-'}
                      </td>
                      <td className="text-sm text-center border px-5 py-3.5 border-[#F0F0F0]">
                        {item.totalCount ?? '-'}
                      </td>
                      <td className="text-sm text-center border px-5 py-3.5 border-[#F0F0F0]">
                        {actionButton}
                      </td>
                    </tr>
                  )
                })}
          </tbody>
        </table>
      </div>
      {/* Skeleton animation keyframes */}
      <style>{`
            @keyframes skeleton-loading {
                0% { background-position: 100% 50%; }
                100% { background-position: 0 50%; }
            }
        `}</style>
      <style>{`
        .custom-dropdown-option:not(:last-child) {
          border-bottom: 1px solid #eee;
        }
      `}</style>
    </section>
  )
}

export default ActPracticeTest
